
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      currentTab: ``,
    };
  },
  inject: [`lastUpdated`],
  computed: {
    statsConfig () {
      return this.additionalConfig?.match_centre_config?.team_stats;
    },
    tabs () {
      if (this.statsConfig) {
        return this.statsConfig.map(group => group.display_name);
      }
      return [];
    },
  },
  mounted () {
    this.currentTab = this.tabs[0];
  },
  methods: {
    setTab (tab) {
      this.currentTab = tab;
    },
  },
};
